import { useParameterStore, ValidationStatus } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { Status } from "@/types/containerTypes";
import { ParameterSubjectType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { useShallow } from "zustand/react/shallow";
import { StepFailureModal } from "../containers/StepFailureModal";
import { ValidationsFailedIcon } from "../validations/ValidationsFailedIcon";
import { ValidationsPassingIcon } from "../validations/ValidationsPassingIcon";
import { ParameterTitle } from "./ParameterTypeLabel";
import { ViewValidationsButton } from "../validations/ViewValidationsButton";
import { ParameterUpdateValueWithContextLogModal } from "./ParameterUpdateWithContextLogModal";
import { ParameterRunEditParameterContent } from "./ParameterRunEditParameterContent";

export function ParameterEditModalCard(props: { parameter: Parameter }) {
  const { parameter } = props;
  const validationStatuses = useParameterStore(useShallow(state => state.getValidationStatusesForSubject(parameter.id)));
  const steps = useTreeStore(useShallow(state => state.containers));
  const containerClass = validationStatuses.some(v => v === ValidationStatus.FAILING) ? 'border border-danger rounded' : '';
  const step = steps.find(s => s.id === parameter.subjectId);

  return (
    <div className={`card ${containerClass}`} key={`parameter-run-edit-content-${parameter.id}`}>
      <div className='card-header d-flex justify-content-between'>
        <div className='d-flex gap-1 align-items-center'>
          <ParameterTitle parameter={parameter} />
          { validationStatuses.every(v => v === ValidationStatus.PASSING) && (
            <div className='d-flex align-items-center gap-2 mb-1'>
              <div className='mb-1'><ValidationsPassingIcon /></div>
              <span className='text-muted small'>{I18n.get('validationsAllPassing')}</span>
              <ViewValidationsButton parameter={parameter} placement='left' />
            </div>
          )}
          { validationStatuses.some(v => v === ValidationStatus.FAILING) && <div className='mb-2'><ValidationsFailedIcon singleValidation /></div>}
        </div>
        <div className='d-flex gap-1'>
          {(validationStatuses.some(v => v === ValidationStatus.FAILING) && parameter.subjectType === ParameterSubjectType.STEP && step?.status === Status.PENDING) && (
            <StepFailureModal stepId={step?.id as string} />
          )}
          <ParameterUpdateValueWithContextLogModal parameter={parameter} />
        </div>
      </div>
      <ParameterRunEditParameterContent key={parameter.id} parameter={parameter} />
    </div>
  );
}
